import { Typography } from "antd"
import { useTranslation } from "react-i18next"

import { BILLING_DESCRIPTOR_ARTICLE_URL } from "../../utils/constants/helpUrl"

import styles from "./BillingDescriptorArticleCard.module.less"

const { Text } = Typography

const BookIcon = () => (
  <svg viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.75 0C1.23122 0 0 1.23122 0 2.75V17.25C0 18.7688 1.23122 20 2.75 20H14.25C15.2165 20 16 19.2165 16 18.25V1.75C16 0.783502 15.2165 0 14.25 0H2.75ZM1.5 17V17.25C1.5 17.9404 2.05964 18.5 2.75 18.5H14.25C14.3881 18.5 14.5 18.3881 14.5 18.25V15.4823C14.4183 15.494 14.3349 15.5 14.25 15.5H3C2.17157 15.5 1.5 16.1716 1.5 17ZM4.75 4.25C4.33579 4.25 4 4.58579 4 5C4 5.41421 4.33579 5.75 4.75 5.75H11.25C11.6642 5.75 12 5.41421 12 5C12 4.58579 11.6642 4.25 11.25 4.25H4.75ZM4 9C4 8.58579 4.33579 8.25 4.75 8.25H8.25C8.66421 8.25 9 8.58579 9 9C9 9.41421 8.66421 9.75 8.25 9.75H4.75C4.33579 9.75 4 9.41421 4 9Z"
      fill="#225AEA"
    />
  </svg>
)

const ChevronRightIcon = () => (
  <svg
    viewBox="0 0 3.72386 6.66667"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.195262 0.195262C0.455612 -0.0650874 0.877722 -0.0650874 1.13807 0.195262L3.33333 2.39052C3.85403 2.91122 3.85403 3.75544 3.33333 4.27614L1.13807 6.4714C0.877722 6.73175 0.455612 6.73175 0.195262 6.4714C-0.0650874 6.21105 -0.0650874 5.78894 0.195262 5.5286L2.39052 3.33333L0.195262 1.13807C-0.0650874 0.877722 -0.0650874 0.455612 0.195262 0.195262Z"
      fill="#225AEA"
    />
  </svg>
)

const Index = ({ videoTitle }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.section}>
      <Text className={styles.label}>{t(videoTitle)}</Text>
      <a
        href={BILLING_DESCRIPTOR_ARTICLE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.card}
      >
        <div className={styles.iconWrapper}>
          <BookIcon />
        </div>
        <div className={styles.content}>
          <Text strong className={styles.title}>
            {t("What is a billing descriptor?")}
          </Text>
          <Text type="secondary" className={styles.description}>
            {t(
              "A billing (or statement) descriptor appears on bank statements to help customers recognize their transactions. Keep reading to learn why creating the right descriptor is essential for preventing chargebacks."
            )}
          </Text>
        </div>
        <div className={styles.chevronWrapper}>
          <ChevronRightIcon />
        </div>
      </a>
    </div>
  )
}

export default Index
